<template>
  <!-- десктоп: каналы колонками в таблице -->
  <div class="table-responsive d-none d-md-block">
    <table class="table">
      <thead>
        <tr>
          <th class="table_first_row" style="width: 16%" scope="col"></th>
          <template v-for="data of dataset" :key="data.datasets[0].label">
            <th :style="{ width: channelColumnWidth }" scope="col">
              <div class="th-inner">
                <img :src="channelsInfo[data.datasets[0].label].icon" />
                <!-- name and hint share one inline flow so the hint icon
                     always follows the last word, even when the title wraps -->
                <div class="th-label">
                  <span
                    class="name"
                    v-html="channelsInfo[data.datasets[0].label].title"
                  ></span><WidgetHint
                    :hintOptions="{
                      name: channelsInfo[data.datasets[0].label].hintName,
                      title: channelsInfo[data.datasets[0].label].hintTitle,
                      actualDate,
                      platforms,
                    }"
                  />
                </div>
              </div>
            </th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(domain, siteIndex) in dataset[0].labels" :key="siteIndex">
          <th class="table_first_row" style="width: 16%" scope="row">
            <Domain :maxWidth="'maxWidth'" :domain="domain" />
          </th>
          <template v-for="channel of dataset" :key="channel.datasets[0].label">
            <td>
              <IndicatorTable
                :value="valueHandler(getValue(channel, siteIndex, value_type))"
                :width="getWidth(channel, siteIndex, value_type)"
                type="marketing-channels"
              />
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- мобилка: каналы строчками одного домена, как в виджете географии;
       домен выбирается общим DomainPicker (selectedDomain из стора) -->
  <div class="mobile_channels d-md-none">
    <!-- один ряд: домен слева, выбор формата значений (% / #) справа -->
    <div class="mobile_header">
      <DomainPicker
        v-if="dataset[0].labels.length > 1"
        type="local"
        class="site_picker"
      />
      <Domain
        v-else
        :maxWidth="'maxWidth'"
        :domain="dataset[0].labels[0]"
        class="site_domain"
      />
      <slot name="mobileControls"></slot>
    </div>
    <div class="site_block">
      <div
        v-for="channel of dataset"
        :key="channel.datasets[0].label"
        class="channel_row"
      >
        <div class="channel_head">
          <img :src="channelsInfo[channel.datasets[0].label].icon" />
          <div class="th-label">
            <span
              class="name"
              v-html="channelsInfo[channel.datasets[0].label].title"
            ></span><WidgetHint
              :hintOptions="{
                name: channelsInfo[channel.datasets[0].label].hintName,
                title: channelsInfo[channel.datasets[0].label].hintTitle,
                actualDate,
                platforms,
              }"
            />
          </div>
        </div>
        <IndicatorTable
          :value="valueHandler(getValue(channel, mobileSiteIndex, value_type))"
          :width="getWidth(channel, mobileSiteIndex, value_type)"
          type="marketing-channels"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Favicon from '@/components/shared/Favicon.vue'
import DomainPicker from '@/components/DomainPicker.vue'
import Domain from '@/components/widgets/widgets-helpers/Domain.vue'
import WidgetHint from '@/components/widgets/widgets-helpers/WidgetHint.vue'
import IndicatorTable from '@/components/widgets/widgets-helpers/IndicatorTable.vue'
import nFormatter from '@/helpers/processing/nFormatter'

export default {
  data() {
    return {}
  },
  components: {
    Favicon,
    Domain,
    DomainPicker,
    IndicatorTable,
    WidgetHint,
  },
  props: [
    'channelsInfo',
    'valueHandler',
    'value_type',
    'dataset',
    'platforms',
    'actualDate',
  ],
  computed: {
    ...mapGetters(['selectedDomain']),
    // индекс выбранного домена в данных виджета; если его там нет — первый
    mobileSiteIndex() {
      const index = this.dataset[0].labels.indexOf(this.selectedDomain)
      return index >= 0 ? index : 0
    },
    channelColumnWidth() {
      return `${84 / (this.dataset.length || 1)}%`
    },
  },
  methods: {
    nFormatter,
    getValue(channel, siteIndex, value_type = 'percent') {
      const value = channel.datasets[0].data[siteIndex][value_type]
      if (!value) return null
      const postFix = value_type === 'percent' ? '%' : ''
      const formattedValue = this.nFormatter(value)
      return postFix ? value + postFix : formattedValue
    },
    getWidth(channel, siteIndex, value_type) {
      const value = channel.datasets[0].data[siteIndex][value_type]
      if (!value) return 0
      if (value_type === 'absolute')
        return `${channel.datasets[0].data[siteIndex].absolute_percent}%`
      return `${channel.datasets[0].data[siteIndex][value_type]}%`
    },
  },
}
</script>

<style scoped>
table {
  font-size: 14px;
  table-layout: fixed;
  min-width: 1200px;
}
table th,
table td {
  font-weight: 400;
  border-top: 1px solid var(--border-color);
}

thead tr {
  background: var(--bg-hover);
  border-radius: 4px;
  color: var(--text-secondary2);
  font-size: 13px;
}

thead th {
  vertical-align: middle !important;
  padding: 14px 8px;
}

thead th div svg {
  cursor: pointer;
}

thead th .th-inner {
  display: flex;
  align-items: center;
}

thead th .th-inner img {
  flex-shrink: 0;
}

thead th .th-label {
  margin-left: 7px;
  min-width: 0;
  text-wrap: balance;
}

thead th .th-label :deep(.hint) {
  margin-left: 4px;
  vertical-align: middle;
  position: relative;
  top: -2px;
}

thead tr th,
tbody tr:first-child th,
tbody tr td {
  border: none;
}

tbody th,
tbody td {
  padding-top: 4px;
  padding-bottom: 2px;
  vertical-align: middle;
}

tbody td span {
  margin-bottom: 5px;
}

.table-responsive::-webkit-scrollbar,
.table-responsive::-webkit-scrollbar-thumb {
  height: 10px;
  border-radius: 50px;
  background-clip: padding-box;
  border: 3px solid var(--bg-surface);
}

.table-responsive::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
}

/* мобильный вид: каналы строчками */
.mobile_channels .mobile_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.mobile_channels .site_domain {
  font-weight: 600;
}

.mobile_channels .channel_row {
  padding: 8px 0 9px;
  border-top: 1px solid var(--border-color);
}

.mobile_channels .channel_head {
  display: flex;
  align-items: center;
  color: var(--text-secondary2);
  font-size: 13px;
  margin-bottom: 5px;
}

.mobile_channels .channel_head img {
  flex-shrink: 0;
}

.mobile_channels .channel_head .th-label {
  margin-left: 7px;
  min-width: 0;
}

.mobile_channels .channel_head :deep(.hint) {
  margin-left: 4px;
  vertical-align: middle;
  position: relative;
  top: -2px;
}

.mobile_channels :deep(.indicator_background.marketing-channels) {
  padding: 6px 12px;
  font-size: 14px;
  line-height: 20px;
  /* стек-контекст, чтобы полоска (z-index: -1) не уходила под фон виджета —
     в таблице это делает правило .indicator_background:first-child */
  z-index: 3;
}
</style>
